import { Injectable }                 from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { tokenNotExpired,
         JwtHelper }                  from 'angular2-jwt';
import { AuthService }                from '../shared/auth.service';
import { MatSnackBar }                 from '@angular/material';
import { Globals }                    from './globals';


@Injectable()
export class AuthGuard implements CanActivate {
  private jwtHelper = new JwtHelper();

  private lastTimestamp: number = null;

  private snackTimeout: any;
  private logoutTimeout: any;
  private logoutTimeoutSnack: any;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private globals: Globals
    ) {
      this.lastTimestamp = new Date().getTime();
    }

  tokenValid() {
    // this.handleSlidingExpiration();
    return tokenNotExpired();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.data !== null &&
      typeof route.data.portalType !== 'undefined' &&
      route.data.portalType !== this.globals.portalType) {
        // this.snackbar.open('Přístup zamítnut', 'OK', { duration: 4000 });
        this.router.navigate(['/login']);
    }

    if (!!this.snackTimeout) {
      clearTimeout(this.snackTimeout);
    }
    if (!!this.logoutTimeout) {
      clearTimeout(this.logoutTimeout);
    }

    if (!!this.logoutTimeoutSnack) {
      this.logoutTimeoutSnack.dismiss();
    }

    this.snackTimeout = setTimeout(() => {
        if (location.href.indexOf('login') === -1) {
          this.logoutTimeoutSnack = this.snackbar.open('Za méně než minutu budete automaticky odhlášeni.', null, { duration: 59900 });
      }}, (1000 * 60 * 29)); // 29 minutes

    this.logoutTimeout = setTimeout(() => {
      if (location.href.indexOf('login') === -1) {
        sessionStorage.removeItem('id_token');
        location.reload();
      }}, (1000 * 60 * 30));  // 30 minutes

    let minutesFromLastCall = ((new Date()).getTime() - this.lastTimestamp) / (1000 * 60 * 30); // 30 minutes
    if (minutesFromLastCall > 30) {
      sessionStorage.removeItem('id_token');
      this.router.navigate(['/login']);
      return false;
    } else {
      this.lastTimestamp = new Date().getTime();
    }

    let token = sessionStorage.getItem('id_token');
    if (tokenNotExpired('id_token', token)) {
      this.handleSlidingExpiration();
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  private handleSlidingExpiration() {
    let token = sessionStorage.getItem('id_token');
    if (!token) { return; }

    // let expirationDate = this.jwtHelper.getTokenExpirationDate(token);
    let dToken = this.jwtHelper.decodeToken(token);
    let refreshLimit = new Date((dToken.iat + (dToken.exp - dToken.iat) / 2) * 1000);

    if (new Date() > refreshLimit) {
      // this.authService.refreshToken().subscribe(res => console.log("Token refreshed"));
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/auth.guard.ts